module.exports = __webpack_public_path__ + "static/media/PDF_83.4be37699.pdf";